const INQUIRY_SUBMIT_ERROR_MESSAGE =
  "We couldn't submit your inquiry. Please try again or contact us directly.";

function getInquirySubmitErrorMessage(
  error: string | undefined,
): string | undefined {
  if (!error) {
    return undefined;
  }

  if (error === "Invalid form configuration") {
    return INQUIRY_SUBMIT_ERROR_MESSAGE;
  }

  return error;
}

export { getInquirySubmitErrorMessage };
